<template>
  <v-container class="my-5">
    <h2 class="subheading grey--text">Accesos al Club</h2>

    <v-card class="elevation-0 mt-4">
      <v-card-title>
        Registro de Accesos
      </v-card-title>
      <v-card-text>
        <v-layout row wrap class="mb-3">
          <v-flex xs12 sm4>
            <v-text-field
                v-model="filter"
                prepend-icon="mdi-magnify"
                label="Buscar acceso"
                clearable
                outlined
                dense
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-select
                v-model="typeFilter"
                :items="['Todos', 'Entrada', 'Salida']"
                label="Tipo de Acceso"
                outlined
                dense
            ></v-select>
          </v-flex>
          <v-flex xs12 sm4>
            <v-select
                v-model="dateFilter"
                :items="['Hoy', 'Esta Semana', 'Este Mes', 'Todo']"
                label="Rango de Fecha"
                outlined
                dense
            ></v-select>
          </v-flex>
        </v-layout>

        <v-data-table
            :headers="headers"
            :items="filteredData"
            :search="filter"
            class="elevation-1"
            no-data-text="No hay registros de acceso"
        >
          <template v-slot:item.access_type="{ item }">
            <v-chip
                :color="item.access_type === 'Entrada' ? 'green' : 'red'"
                text-color="white"
                small
            >
              {{ item.access_type }}
            </v-chip>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
                :color="item.status === 'Autorizado' ? 'green' : 'orange'"
                text-color="white"
                small
            >
              {{ item.status }}
            </v-chip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'ClubHouseAccesses',
  data () {
    return {
      filter: '',
      typeFilter: 'Todos',
      dateFilter: 'Hoy',
      headers: [
        { text: 'Miembro', value: 'member_name', sortable: true },
        { text: 'Hora', value: 'time', sortable: true },
        { text: 'Tipo', value: 'access_type', sortable: true },
        { text: 'Amenidad', value: 'amenity', sortable: true },
        { text: 'Estado', value: 'status', sortable: true }
      ],
      accesses: [
        {
          id: 1,
          member_name: 'Carlos López',
          time: '2026-08-29 08:15',
          access_type: 'Entrada',
          amenity: 'Cancha de Golf',
          status: 'Autorizado'
        },
        {
          id: 2,
          member_name: 'Ana Rodríguez',
          time: '2026-08-29 09:30',
          access_type: 'Entrada',
          amenity: 'Centro Fitness',
          status: 'Autorizado'
        },
        {
          id: 3,
          member_name: 'Roberto García',
          time: '2026-08-29 10:45',
          access_type: 'Salida',
          amenity: 'Restaurante',
          status: 'Autorizado'
        },
        {
          id: 4,
          member_name: 'Laura Fernández',
          time: '2026-08-29 11:20',
          access_type: 'Entrada',
          amenity: 'Piscina Olímpica',
          status: 'Autorizado'
        },
        {
          id: 5,
          member_name: 'Miguel Torres',
          time: '2026-08-29 12:00',
          access_type: 'Entrada',
          amenity: 'Salón de Eventos',
          status: 'Autorizado'
        },
        {
          id: 6,
          member_name: 'Patricia Sánchez',
          time: '2026-08-29 13:15',
          access_type: 'Salida',
          amenity: 'Cancha de Tenis',
          status: 'Autorizado'
        },
        {
          id: 7,
          member_name: 'Diego Flores',
          time: '2026-08-29 14:00',
          access_type: 'Entrada',
          amenity: 'Spa y Wellness',
          status: 'Autorizado'
        },
        {
          id: 8,
          member_name: 'María González',
          time: '2026-08-29 14:45',
          access_type: 'Entrada',
          amenity: 'Centro Fitness',
          status: 'Autorizado'
        },
        {
          id: 9,
          member_name: 'Juan Martínez',
          time: '2026-08-29 15:30',
          access_type: 'Salida',
          amenity: 'Cancha de Golf',
          status: 'Autorizado'
        },
        {
          id: 10,
          member_name: 'Fernando Ruiz',
          time: '2026-08-29 16:00',
          access_type: 'Entrada',
          amenity: 'Biblioteca',
          status: 'Autorizado'
        }
      ]
    }
  },
  computed: {
    filteredData () {
      let filtered = this.accesses
      if (this.typeFilter !== 'Todos') {
        filtered = filtered.filter(acc => acc.access_type === this.typeFilter)
      }
      return filtered
    }
  }
}
</script>

<style scoped>
</style>
